import moment from 'moment';

export function mapDerivedGrowthChart(data: any): any {
    let recYear: number;
    let recMonth: number;
    if (data.growthChart.takenAt) {
        recYear = parseInt(moment(data.growthChart.takenAt).format('YYYY'));
        recMonth = parseInt(moment(data.growthChart.takenAt).format('M'));
    } else if (data.growthChart.originalCreationAt) {
        recYear = parseInt(moment(data.growthChart.originalCreationAt).format('YYYY'));
        recMonth = parseInt(moment(data.growthChart.originalCreationAt).format('M'));
    } else if (data.growthChart.createdAt) {
        recYear = parseInt(moment(data.growthChart.createdAt).format('YYYY'));
        recMonth = parseInt(moment(data.growthChart.createdAt).format('M'));
    } else {
        return undefined;
    }

    data.recordBdayYear = recYear;
    data.recordBdayMonth = recMonth - 1;
    data.recordBdayDiff = data.recordBdayYear - data.pxBdayYear;

    data.yearCount = data.recordBdayDiff * 12;

    data.index = (data.recordBdayMonth + data.yearCount) - data.pxBdayMonth;

    return data;
}

export function kgCmToBMI(rawWeight: number, rawHeight: number): number {
    let weight: number = 0;
    let height: number = 0;
    
    if(rawHeight)
        height = rawHeight;

    if(rawWeight)
        weight = rawWeight;

    let finalBmi = 0;

    height = height / 100;
    finalBmi = weight / (height * height);
    
    return finalBmi ? finalBmi : null;
}